(function () {
  'use strict';

  // Use a runtime-specific guard. Earlier CRM assets used the broader
  // __ssStorefrontSessionHelperInstalled flag, which could prevent this bridge
  // from starting when another storefront helper happened to claim it first.
  if (window.__ssProductOptionsRuntimeInstalled) return;
  window.__ssProductOptionsRuntimeInstalled = true;
  document.documentElement.setAttribute('data-product-options-runtime', '20260826-exact-field-value-evidence-1');

  var rootSelector = '#customily-options, .customily-main-app, .customily-options-wrapper, .customily_gallery';
  var variantSelector = 'variant-selects, variant-radios, .product-form__input, .product-form__input--option-material, [data-variant-picker], [data-option-selector]';
  var previewSelector = '.customily_gallery_media, .customily_gallery .canvas-container, .customily_gallery canvas, .customily_gallery img, [class*="customily"] img';
  var atcSelector = 'button[name="add"], button.product-form__submit, [data-add-to-cart]';
  var firstPartyEndpoint = '/apps/product-options';
  var browserEventEndpoint = firstPartyEndpoint + '/events';
  var previewUploadEndpoint = firstPartyEndpoint + '/preview-images/';
  var trackingConfigEndpoint = firstPartyEndpoint + '/config';
  var pendingCartStorageKey = 'sscrm_pending_cart_snapshot_v2';
  var OBSERVER_DEBOUNCE_MS = 200;
  var HANDLER_BUDGET_MS = 5;
  var LONG_TASK_BUDGET_MS = 50;
  var CONFIG_REFRESH_MS = 60000;
  var state = {
    enabled: false,
    initialized: false,
    disabledReason: 'config_pending',
    previewObserver: null,
    observerTimer: 0,
    observerRootTimer: 0,
    configTimer: 0,
    started: false,
    previewRequested: false,
    previewCycle: 0,
    previewCreatedCycle: 0,
    previewCompletedCycles: {},
    lastPreviewClickAt: 0,
    previewVisible: false,
    saved: false,
    lastPayloads: {},
    changeTimer: 0,
    lastAtcSnapshotAt: 0,
    lastPreviewUrl: '',
    lastMaterial: '',
    customerSelectionValues: {},
    customerSelectionNames: {},
    customerSelectionOwners: {},
    customerSelectionOrder: [],
    activeBreedSlot: 0,
    activeBreedSlotChangedAt: 0,
    snapshotSequence: 0,
    previewSnapshots: {},
    previewUploads: {},
    previewUrlSyncs: {},
    previewCompletingCycles: {},
    pendingCartRecovery: false,
    prewarmedPreview: null,
    prewarmPreviewPromise: null,
    lastTrustedInteractionAt: 0,
    selectionProductHandle: '',
    budgetBreaches: {},
    previewCapturePausedUntil: 0,
    visitorId: '',
    sessionId: '',
    sessionLastSeenAt: 0,
    sessionStartedAt: 0,
    engagementTimer: 0,
    engagementListenersInstalled: false,
    lastEngagementSentAt: 0
  };

  function analyticsProcessingAllowed() {
    try {
      return Boolean(
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (_error) {
      return false;
    }
  }

  function trackingAllowed() {
    return state.enabled &&
      window.__soulyshineCrmDisabled !== true &&
      analyticsProcessingAllowed();
  }

  function stopPreviewObserver() {
    window.clearTimeout(state.observerTimer);
    window.clearTimeout(state.observerRootTimer);
    state.observerTimer = 0;
    state.observerRootTimer = 0;
    if (state.previewObserver) state.previewObserver.disconnect();
    state.previewObserver = null;
  }

  function disableTracking(reason) {
    state.enabled = false;
    state.disabledReason = clean(reason || 'disabled', 120);
    document.documentElement.setAttribute('data-product-options-runtime-state', state.disabledReason);
    state.previewRequested = false;
    stopPreviewObserver();
    window.clearTimeout(state.changeTimer);
    state.changeTimer = 0;
    window.clearTimeout(state.engagementTimer);
    state.engagementTimer = 0;
  }

  function runBudgeted(label, task) {
    if (!trackingAllowed()) return;
    var clock = window.performance && typeof window.performance.now === 'function'
      ? window.performance
      : { now: Date.now };
    var startedAt = clock.now();
    try {
      var result = task();
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (_error) {
      return;
    }
    var elapsed = clock.now() - startedAt;
    if (elapsed > HANDLER_BUDGET_MS) {
      state.budgetBreaches[label] = (state.budgetBreaches[label] || 0) + 1;
    }
    if (elapsed >= LONG_TASK_BUDGET_MS) {
      // Protect the storefront by pausing image work only. Never disable event
      // tracking or interfere with Customily/Shopify after one slow task.
      state.previewCapturePausedUntil = Date.now() + 60000;
      stopPreviewObserver();
    } else if (elapsed > HANDLER_BUDGET_MS && /^(?:click|change|input|option_click|preview_mutation)$/i.test(label)) {
      // Polling retries remain active, so stopping the observer reduces DOM work
      // without losing the Preview lifecycle or touching the commerce action.
      stopPreviewObserver();
    }
  }

  function deferTracking(label, task, delay) {
    return window.setTimeout(function () {
      runBudgeted(label, task);
    }, Math.max(0, delay || 0));
  }

  function deferIdle(label, task, timeout) {
    if (!trackingAllowed()) return;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () {
        runBudgeted(label, task);
      }, { timeout: timeout || 1000 });
      return;
    }
    deferTracking(label, task, 0);
  }

  function clean(value, maxLength) {
    if (value === undefined || value === null) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, maxLength || 256);
  }

  function randomId(prefix) {
    try {
      return prefix + crypto.randomUUID().replace(/-/g, '');
    } catch (_error) {
      return prefix + Date.now().toString(36) + Math.random().toString(36).slice(2);
    }
  }

  function ensureBrowserIdentity() {
    var now = Date.now();
    try {
      state.visitorId = clean(window.localStorage.getItem('ss_v2_vid'), 180);
      if (!state.visitorId) {
        state.visitorId = randomId('ssv2_');
        window.localStorage.setItem('ss_v2_vid', state.visitorId);
      }
      var saved = JSON.parse(window.localStorage.getItem('ss_v2_session') || 'null');
      var lastSeenAt = Number(saved && saved.lastSeenAt || 0);
      if (saved && clean(saved.id, 180) && now - lastSeenAt < 30 * 60 * 1000) {
        state.sessionId = clean(saved.id, 180);
        state.sessionStartedAt = Number(saved.startedAt || now);
      } else {
        state.sessionId = randomId('sss2_');
        state.sessionStartedAt = now;
      }
      state.sessionLastSeenAt = now;
      window.localStorage.setItem('ss_v2_session', JSON.stringify({
        id: state.sessionId,
        lastSeenAt: now,
        startedAt: state.sessionStartedAt
      }));
    } catch (_error) {
      state.visitorId = state.visitorId || randomId('ssv2_');
      state.sessionId = state.sessionId || randomId('sss2_');
      state.sessionStartedAt = state.sessionStartedAt || now;
      state.sessionLastSeenAt = now;
    }
  }

  function touchBrowserSession() {
    var now = Date.now();
    if (!state.visitorId || !state.sessionId || now - state.sessionLastSeenAt >= 30 * 60 * 1000) {
      ensureBrowserIdentity();
      return;
    }
    state.sessionLastSeenAt = now;
    try {
      window.localStorage.setItem('ss_v2_session', JSON.stringify({
        id: state.sessionId,
        lastSeenAt: now,
        startedAt: state.sessionStartedAt || now
      }));
    } catch (_error) {}
  }

  function firstPartySource(eventName) {
    return eventName === 'customer_identified' ? 'klaviyo' : 'customily';
  }

  function sendFirstPartyEvent(eventName, data, source, preferBeacon) {
    if (!trackingAllowed()) return false;
    touchBrowserSession();
    // Never mutate the caller's object. initialize() deliberately reuses its
    // page context for page_viewed and product_viewed; mutating it previously
    // gave both events the same idempotency key and D1 discarded one of them.
    var properties = Object.assign({}, data || {});
    var bridgeEventId = clean(properties.bridgeEventId, 180) || randomId('sse_');
    properties.bridgeEventId = bridgeEventId;
    properties.sessionElapsedSeconds = Math.max(0, Math.floor(
      (Date.now() - (state.sessionStartedAt || Date.now())) / 1000
    ));
    var payload = {
      eventId: bridgeEventId,
      idempotencyKey: 'storefront:' + bridgeEventId,
      eventName: eventName,
      source: source || firstPartySource(eventName),
      visitorId: state.visitorId,
      sessionId: state.sessionId,
      occurredAt: new Date().toISOString(),
      properties: properties
    };
    try {
      var body = JSON.stringify(payload);
      if (body.length > 60000) return false;
      document.documentElement.setAttribute('data-product-options-last-delivery', 'dispatching-' + clean(eventName, 60));
      function beaconFallback() {
        try {
          if (!window.navigator || typeof window.navigator.sendBeacon !== 'function') return false;
          var sent = window.navigator.sendBeacon(
            browserEventEndpoint,
            new Blob([body], { type: 'application/json' })
          );
          document.documentElement.setAttribute(
            'data-product-options-last-delivery',
            (sent ? 'beacon-queued-' : 'beacon-rejected-') + clean(eventName, 60)
          );
          return sent;
        } catch (_beaconError) {
          document.documentElement.setAttribute('data-product-options-last-delivery', 'beacon-failed-' + clean(eventName, 60));
          return false;
        }
      }
      if (preferBeacon && beaconFallback()) return true;
      window.fetch(browserEventEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: body.length <= 60000
      }).then(function (response) {
        document.documentElement.setAttribute(
          'data-product-options-last-delivery',
          (response.ok ? 'accepted-' : 'http-' + response.status + '-') + clean(eventName, 60)
        );
        if (!response.ok) beaconFallback();
      }).catch(function () {
        beaconFallback();
      });
      return true;
    } catch (_error) {
      try {
        if (body) return beaconFallback();
      } catch (_fallbackError) {}
      return false;
    }
  }

  function recordSessionEngagement(trigger, preferBeacon) {
    if (!trackingAllowed()) return;
    var now = Date.now();
    var elapsed = Math.max(0, Math.floor((now - (state.sessionStartedAt || now)) / 1000));
    if (elapsed < 1 || now - state.lastEngagementSentAt < 1000) return;
    state.lastEngagementSentAt = now;
    sendFirstPartyEvent('session_engaged', {
      pageUrl: clean(window.location.origin + window.location.pathname, 2048),
      productHandle: productHandle() || undefined,
      engagementTrigger: clean(trigger, 40),
      sessionElapsedSeconds: elapsed
    }, 'shopify_pixel', preferBeacon === true);
  }

  function startSessionMeasurement() {
    if (!trackingAllowed()) return;
    window.clearTimeout(state.engagementTimer);
    state.engagementTimer = window.setTimeout(function () {
      recordSessionEngagement('ten_second_timer', false);
    }, 10000);
    if (state.engagementListenersInstalled) return;
    state.engagementListenersInstalled = true;
    window.addEventListener('pagehide', function () {
      recordSessionEngagement('pagehide', true);
    }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') recordSessionEngagement('visibility_hidden', true);
    }, { passive: true });
  }

  function normalizedName(field) {
    return clean(field && field.name, 256)
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .toLowerCase();
  }

  function canonicalLabel(value) {
    return clean(value, 256)
      .replace(/^option\s+\d+\s+of\s+\d+\s*/i, '')
      .replace(/\s*\(\s*\d+\s*[|/]\s*\d+\s*\)\s*\*?\s*required\s*$/i, '')
      .replace(/\s*\*+\s*required\s*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function propertyLabel(field) {
    var name = clean(field && field.name, 256).replace(/[\u200B-\u200D\uFEFF]/g, '');
    var match = name.match(/^properties\[(.*)\]$/i);
    return match ? canonicalLabel(match[1]) : '';
  }

  function isUsableField(field) {
    if (!field || field.disabled) return false;
    if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return false;
    return true;
  }

  function fields() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '#customily-options input, #customily-options select, #customily-options textarea, ' +
      'form[action*="/cart/add"] input, form[action*="/cart/add"] select, ' +
      'form[action*="/cart/add"] textarea, input[name="Material"], select[name="Material"], ' +
      'input[name="options[Material]"], select[name="options[Material]"], ' +
      'input[name="properties[_customily-preview]"], input[name="properties[_customily-thumb]"]'
    )).filter(isUsableField);
  }

  // This is deliberately scoped to Customily controls. It is evaluated only
  // when Preview/Add to cart is clicked, never while the customer is typing,
  // and never prevents the commerce action. It only decides whether CRM may
  // commit a snapshot of the customer's personalization.
  function customilyFormFields() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '#customily-options input, #customily-options select, #customily-options textarea, ' +
      '.customily-main-app input, .customily-main-app select, .customily-main-app textarea, ' +
      '.customily-options-wrapper input, .customily-options-wrapper select, .customily-options-wrapper textarea'
    )).filter(function (field) {
      return field && !field.disabled && field.type !== 'hidden';
    });
  }

  function selectedCustomizationCount(allFields) {
    for (var index = 0; index < allFields.length; index += 1) {
      var field = allFields[index];
      var label = canonicalLabel(propertyLabel(field) || fieldLabel(field));
      if (!/choose\s+number\s+of\s+(?:pets?|dogs?|cats?|charms?)/i.test(label)) continue;
      if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) continue;
      var match = clean(field.value, 80).match(/\d+/);
      if (match && Number(match[0]) > 0) return Number(match[0]);
    }
    return 0;
  }

  function fieldSlot(field) {
    var label = canonicalLabel(propertyLabel(field) || fieldLabel(field));
    var match = label.match(/#\s*(\d+)/);
    return Number(match && match[1] || 0);
  }

  function requiredCustomilyField(field) {
    if (!field || field.disabled) return false;
    if (field.required || field.getAttribute('aria-required') === 'true' || field.getAttribute('data-required') === 'true') return true;
    // An unchecked Customily add-on checkbox is a valid customer choice. Some
    // option sets label every option as "Required" even when the checkbox is
    // an optional upsell, so only a native/direct required flag may require it.
    if (field.type === 'checkbox') return false;
    var rawName = clean(field.name, 500);
    if (/\*\s*required\s*\]?$/i.test(rawName)) return true;
    var container = field.closest && field.closest('.customily-option, .customily_option, .customily-option-group, [data-required], fieldset');
    if (!container) return false;
    if (container.getAttribute('data-required') === 'true' || container.getAttribute('aria-required') === 'true') return true;
    var label = container.querySelector('legend, .customily-option-label, [class*="label"], label');
    return Boolean(label && /(?:\*\s*required|\*\s*$|\brequired\b)/i.test(clean(label.textContent, 500)));
  }

  function completedRequiredCustomilyField(field, allFields) {
    if (!field || field.disabled) return true;
    if (field.type === 'radio') {
      return allFields.some(function (candidate) {
        return candidate.type === 'radio' && candidate.name === field.name && candidate.checked;
      });
    }
    if (field.type === 'checkbox') return true;
    if (field.type === 'file') return Boolean(field.files && field.files.length);
    if (field.validity && field.validity.valid === false) return false;
    return meaningfulValue(field.value);
  }

  function hasIncompleteRequiredCustomilyFields() {
    var allFields = customilyFormFields();
    var selectedCount = selectedCustomizationCount(allFields);
    return allFields.some(function (field) {
      var slot = fieldSlot(field);
      if (selectedCount > 0 && slot > selectedCount) return false;
      return requiredCustomilyField(field) && !completedRequiredCustomilyField(field, allFields);
    });
  }

  function meaningfulValue(value) {
    return Boolean(value) &&
      !/^(?:choose|select|please choose)(?:\s|$)/i.test(value) &&
      !/^(?:selected|checked|on)$/i.test(value);
  }

  function canonicalMaterial(value) {
    var text = clean(value, 500).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    if (!text) return '';
    if (text.indexOf('18k rose gold vermeil') >= 0 || text.indexOf('rose gold vermeil') >= 0) return '18K Rose Gold Vermeil';
    if (text.indexOf('white gold vermeil') >= 0) return 'White Gold Vermeil';
    if (text.indexOf('10k solid gold') >= 0) return '10K Solid Gold';
    if (text.indexOf('925 sterling silver') >= 0 || text.indexOf('sterling silver') >= 0) return '925 Sterling Silver';
    if (text.indexOf('18k gold vermeil') >= 0 || text.indexOf('gold vermeil') >= 0) return '18K Gold Vermeil';
    if (text.indexOf('18k gold plated') >= 0 || text.indexOf('gold plated') >= 0) return '18K Gold Plated';
    if (text.indexOf('silver plated') >= 0) return 'Silver Plated';
    return '';
  }

  function breedSlotFromLabel(value) {
    var label = clean(value, 200);
    var numbered = label.match(/choose\s+(?:(?:dog|cat)\s+)?breed\s*#?\s*(\d+)/i);
    var ordinal = label.match(/choose\s+(\d+)(?:st|nd|rd|th)\s+(?:(?:dog|cat)\s+)?breed/i);
    var canonical = label.match(/breed(?:\s+(?:group|evidence))?\s*#\s*(\d+)/i);
    return Number(numbered && numbered[1] || ordinal && ordinal[1] || canonical && canonical[1] || 0);
  }

  function isBreedMenuValue(value) {
    return /^(?:[a-z](?:\s*[-–]\s*[a-z])?\s+(?:dog|cat)\s+breeds?|choose\s+breed|select\s+breed)$/i.test(clean(value, 200));
  }

  function breedSlotFromContext(field) {
    var node = field && field.parentElement;
    var depth = 0;
    while (node && depth < 6 && !node.matches(rootSelector)) {
      var directLabels = Array.prototype.slice.call(node.children || []).filter(function (child) {
        return /^(LABEL|LEGEND|H2|H3|H4|P)$/i.test(child.tagName || '') || /label|title|heading/i.test(child.className || '');
      });
      for (var index = 0; index < directLabels.length; index += 1) {
        var slot = breedSlotFromLabel(directLabels[index].textContent);
        if (slot) return slot;
      }
      node = node.parentElement;
      depth += 1;
    }
    return 0;
  }

  function resetSelectionForProduct(handle) {
    state.selectionProductHandle = handle;
    state.customerSelectionValues = {};
    state.customerSelectionNames = {};
    state.customerSelectionOwners = {};
    state.customerSelectionOrder = [];
    state.activeBreedSlot = 0;
    state.activeBreedSlotChangedAt = 0;
    state.lastMaterial = '';
  }

  function ensureSelectionProductContext() {
    var handle = productHandle();
    if (!handle) return;
    if (state.selectionProductHandle && state.selectionProductHandle !== handle) {
      resetSelectionForProduct(handle);
      return;
    }
    state.selectionProductHandle = handle;
  }

  function uniqueActiveAnimalSlot() {
    var slots = [];
    fields().forEach(function (candidate) {
      var label = canonicalLabel(propertyLabel(candidate) || displayLabel(candidate, 0));
      var match = label.match(/^Choose (?:Charm|Pet) #\s*(\d+)$/i);
      if (!match) return;
      var value = displaySelection(candidate, candidate).value;
      if (!/^(?:Dog|Cat)$/i.test(value) || slots.indexOf(match[1]) !== -1) return;
      slots.push(match[1]);
    });
    return slots.length === 1 ? Number(slots[0]) : 0;
  }

  function displayLabel(field, index) {
    var label = propertyLabel(field);
    if (!label) label = clean(field.getAttribute && (field.getAttribute('aria-label') || field.getAttribute('data-label')), 100);
    if (!label && field.labels && field.labels.length) label = clean(field.labels[0].textContent, 100);
    if (!label && field.closest) {
      var group = field.closest('.customily-option, .customily-option-group, fieldset, [class*="option"]');
      var groupLabel = group && group.querySelector('legend, .customily-option-label, [class*="label"], label');
      if (groupLabel) label = clean(groupLabel.textContent, 100);
    }
    if (!label) {
      label = clean(field.name, 100)
        .replace(/^properties\[/i, '')
        .replace(/\]$/u, '')
        .replace(/^_customily[_-]*/i, '')
        .replace(/[_-]+/g, ' ');
    }
    label = canonicalLabel(label) || ('Option ' + (index + 1));
    var slot = /breed/i.test(label) ? breedSlotFromContext(field) : 0;
    if (slot && !/(?:#|number|no\.?\s*)\s*\d+/i.test(label)) {
      label = 'Choose breed #' + slot + ' · ' + label;
    }
    return label;
  }

  function assetName(value) {
    var source = clean(value, 2048);
    if (!source) return '';
    try {
      source = decodeURIComponent(new URL(source, window.location.href).pathname.split('/').pop() || '');
    } catch (_error) {
      source = source.split(/[?#]/)[0].split('/').pop() || '';
    }
    source = source
      .replace(/\.(?:avif|gif|jpe?g|png|svg|webp)$/i, '')
      .replace(/(?:[-_]\d+x\d+|[-_]thumb(?:nail)?|[-_]small|[-_]medium|[-_]large)$/i, '')
      .replace(/[_-]+/g, ' ')
      .trim();
    if (!meaningfulValue(source) || /^(?:customily|image|option|thumbnail|preview)$/i.test(source)) return '';
    if (/^[a-f0-9]{16,}$/i.test(source.replace(/\s+/g, ''))) return '';
    return clean(source, 500);
  }

  // Customily's option-art CDN commonly uses an opaque UUID-like asset ID
  // (for example `g1 f94fc7f4 deb9 41e3 8e5b eff784fd74fa`). It is never a
  // customer-facing breed and must not become analytics evidence.
  function opaqueCustomilyAssetId(value) {
    var text = clean(value, 500);
    return /^(?:[a-z]+\d*[\s_-]+)?[a-f0-9]{8}(?:[\s_-]+[a-f0-9]{4}){3}[\s_-]+[a-f0-9]{12}$/i.test(text) ||
      /^[a-f0-9]{16,}$/i.test(text.replace(/[\s_-]+/g, ''));
  }

  function exactValueFromNode(node) {
    if (!node || !node.getAttribute) return '';
    var attributes = [
      'data-option-name', 'data-name', 'data-title', 'data-alt',
      'alt', 'title', 'aria-label'
    ];
    for (var index = 0; index < attributes.length; index += 1) {
      var candidate = clean(node.getAttribute(attributes[index]), 500);
      if (meaningfulValue(candidate)) return candidate;
    }
    var image = /^(?:IMG|SOURCE)$/i.test(node.tagName || '') ? node : node.querySelector && node.querySelector('img, source');
    if (image) {
      for (var imageIndex = 0; imageIndex < attributes.length; imageIndex += 1) {
        var imageCandidate = clean(image.getAttribute(attributes[imageIndex]), 500);
        if (meaningfulValue(imageCandidate)) return imageCandidate;
      }
      var filename = assetName(image.currentSrc || image.src || image.getAttribute('srcset'));
      if (filename) return filename;
    }
    var dataValue = clean(node.getAttribute('data-value'), 500);
    if (/^https?:\/\//i.test(dataValue)) dataValue = assetName(dataValue);
    if (
      meaningfulValue(dataValue) &&
      !/^[a-f0-9-]{24,}$/i.test(dataValue.replace(/\s+/g, ''))
    ) return dataValue;
    return '';
  }

  function thumbnailValue(field, interactionTarget) {
    var nodes = [];
    if (interactionTarget && interactionTarget.closest) {
      nodes.push(interactionTarget);
      nodes.push(interactionTarget.closest('label, [role="option"], .customily-option, .customily-option-group, [class*="thumbnail"], [class*="swatch"]'));
    }
    if (field && field.closest) {
      nodes.push(field.closest('label, [role="option"], .customily-option, .customily-option-group, [class*="thumbnail"], [class*="swatch"]'));
    }
    for (var index = 0; index < nodes.length; index += 1) {
      var candidate = exactValueFromNode(nodes[index]);
      if (candidate) return candidate;
    }
    return '';
  }

  // Customily breed tiles frequently expose the library name (for example
  // `P-R Dog Breeds`) in data-option-name while the clicked image filename is
  // the actual selected breed. Read that filename only from the customer's
  // click target; never scan gallery/product images or infer a default.
  function clickedTileAssetValue(target) {
    if (!target || !target.closest) return '';
    var node = target.closest('img, label, [role="option"], .customily-option, .customily-option-group, [class*="thumbnail"], [class*="swatch"]');
    var image = node && (/^IMG$/i.test(node.tagName || '') ? node : node.querySelector && node.querySelector('img'));
    if (!image) return '';
    var value = assetName(image.currentSrc || image.src || image.getAttribute('srcset'));
    return meaningfulValue(value) && !isBreedMenuValue(value) && !opaqueCustomilyAssetId(value) ? value : '';
  }

  function displaySelection(field, interactionTarget) {
    if (field.tagName === 'SELECT' && field.selectedIndex >= 0) {
      return {
        value: clean(field.options[field.selectedIndex] && field.options[field.selectedIndex].textContent, 500) || clean(field.value, 500),
        source: 'selected_option'
      };
    }
    if (field.type === 'radio' || field.type === 'checkbox') {
      var thumbnail = thumbnailValue(field, interactionTarget);
      if (thumbnail) return { value: thumbnail, source: 'thumbnail_name' };
      var labelValue = field.labels && field.labels.length
        ? clean(field.labels[field.labels.length - 1].textContent, 500)
        : '';
      if (meaningfulValue(labelValue)) return { value: labelValue, source: 'option_label' };
      var controlValue = clean(field.value, 500);
      return { value: meaningfulValue(controlValue) ? controlValue : '', source: 'control_value' };
    }
    if (field.type === 'file') return { value: field.files && field.files.length ? 'Uploaded' : '', source: 'file_state' };
    return { value: clean(field.value, 500), source: 'input_value' };
  }

  function displayValue(field) {
    return displaySelection(field, null).value;
  }

  function isBackEngravingLabel(value) {
    return /custom\s+back[-\s]*engraved\s+pendant|back[-\s]*engrav(?:e|ed|ing)/i.test(clean(value, 300));
  }

  function isBackMessageLabel(value) {
    return /^(?:custom\s+)?back\s+(?:message|text|engraving\s+message)$/i.test(canonicalLabel(value));
  }

  function backEngravingSelectedInDom() {
    return fields().some(function (field) {
      if (!field || field.type !== 'checkbox' || !field.checked) return false;
      return isBackEngravingLabel(propertyLabel(field) || displayLabel(field, 0) || field.name);
    });
  }

  function rememberCustomerSelection(field, interactionTarget) {
    if (!field || !/^(INPUT|SELECT|TEXTAREA)$/i.test(field.tagName || '')) return;
    ensureSelectionProductContext();
    var list = fields();
    var index = list.indexOf(field);
    var fieldIndex = index >= 0 ? index : state.customerSelectionOrder.length;
    var baseLabel = displayLabel(field, fieldIndex);
    var selection = displaySelection(field, interactionTarget);
    var value = selection.value;
    var typeMatch = baseLabel.match(/^Choose (?:Charm|Pet) #\s*(\d+)$/i);
    if (typeMatch && /^(?:Dog|Cat)$/i.test(value)) {
      state.activeBreedSlot = Number(typeMatch[1]);
      state.activeBreedSlotChangedAt = Date.now();
    }
    // This add-on is a boolean choice. Its surrounding Customily tile can
    // contain product artwork, so deriving its value from a thumbnail records
    // unrelated filenames. Keep only explicit checked state. When unchecked,
    // remove the prior remembered selection so Back Message cannot leak into a
    // later Preview/Add-to-cart snapshot.
    if (field.type === 'checkbox' && isBackEngravingLabel(baseLabel || field.name)) {
      if (!field.checked) {
        var normalizedBackLabel = canonicalLabel(baseLabel).toLowerCase();
        var normalizedBackName = normalizedName(field);
        Object.keys(state.customerSelectionValues).forEach(function (existingLabel) {
          var sameLabel = canonicalLabel(existingLabel).toLowerCase().replace(/\s+\d+$/, '') === normalizedBackLabel;
          var sameName = normalizedBackName && state.customerSelectionNames[existingLabel] === normalizedBackName;
          if (!sameLabel && !sameName) return;
          delete state.customerSelectionValues[existingLabel];
          delete state.customerSelectionNames[existingLabel];
          delete state.customerSelectionOwners[existingLabel];
          state.customerSelectionOrder = state.customerSelectionOrder.filter(function (item) { return item !== existingLabel; });
        });
        return;
      }
      value = 'Selected';
      selection.source = 'checked_toggle';
    }
    // A first-level "A Dog Breeds" / "P-R Cat Breeds" control is a library
    // selector, not the customer's actual breed. Its adjacent dropdown owns
    // the final selected value. Never use the library swatch image as a breed:
    // Customily serves those swatches with opaque asset filenames, which can
    // otherwise be recorded as unrelated text. We retain the group only as
    // customer-interaction evidence, then map its live hidden property below.
    var rawBreedControlValue = clean(field.value, 500);
    if (/breed/i.test(baseLabel)) {
      // Do not infer a breed from Customily artwork. The native control value
      // is either an exact breed (safe to retain) or an alphabetic library
      // group (resolved to its dynamic hidden property at commit time).
      var clickedBreed = interactionTarget && interactionTarget !== field
        ? clickedTileAssetValue(interactionTarget)
        : '';
      value = clickedBreed || rawBreedControlValue;
      selection.source = clickedBreed ? 'clicked_breed_tile' : isBreedMenuValue(value) ? 'breed_group' : 'breed_control';
    }
    if (!baseLabel || !meaningfulValue(value)) return;
    var fieldName = normalizedName(field);
    var fieldId = clean(field.id, 120);
    var contextualSlot = breedSlotFromContext(field) || breedSlotFromLabel(baseLabel);
    // In Pawbond the repeated Customily breed panel can report the previous
    // slot in its DOM label. Immediately after the customer chooses Dog/Cat for
    // a numbered charm, that explicit type click is the authoritative slot for
    // the following group/tile click. Consume it only after an exact tile is
    // chosen so later unrelated breed edits still use their own DOM context.
    if (
      /breed/i.test(baseLabel) &&
      state.activeBreedSlot &&
      state.activeBreedSlotChangedAt &&
      Date.now() - state.activeBreedSlotChangedAt < 30000
    ) contextualSlot = state.activeBreedSlot;
    if (/breed/i.test(baseLabel) && !contextualSlot) contextualSlot = state.activeBreedSlot || uniqueActiveAnimalSlot();
    if (/breed/i.test(baseLabel) && contextualSlot) state.activeBreedSlot = contextualSlot;
    if (/breed/i.test(baseLabel) && !contextualSlot && state.activeBreedSlot) contextualSlot = state.activeBreedSlot;
    var breedMenu = /breed/i.test(baseLabel) && isBreedMenuValue(value);
    if (/breed/i.test(baseLabel) && contextualSlot) {
      baseLabel = (breedMenu ? 'Breed group #' : 'Choose breed #') + contextualSlot;
    }
    if (/breed/i.test(baseLabel) && clickedBreed && !breedMenu) state.activeBreedSlotChangedAt = 0;
    var owner = /breed/i.test(baseLabel) && contextualSlot
      ? (breedMenu ? 'breed-group|' : 'breed-choice|') + contextualSlot
      : (field.type === 'radio' || field.type === 'checkbox')
        ? ['choice-group', fieldName || canonicalLabel(baseLabel).toLowerCase(), contextualSlot].join('|')
        : [fieldName, fieldId, contextualSlot, fieldName || fieldId || contextualSlot ? '' : fieldIndex].join('|');
    // Radio options in one Customily group have different element IDs. Treat the
    // checked option as the authoritative value and remove the previous choice,
    // otherwise a former "Soft" selection can survive after "Slim" is chosen.
    Object.keys(state.customerSelectionOwners).forEach(function (existingLabel) {
      if (state.customerSelectionOwners[existingLabel] !== owner || existingLabel === baseLabel) return;
      delete state.customerSelectionValues[existingLabel];
      delete state.customerSelectionNames[existingLabel];
      delete state.customerSelectionOwners[existingLabel];
      state.customerSelectionOrder = state.customerSelectionOrder.filter(function (item) { return item !== existingLabel; });
    });
    var label = baseLabel;
    var suffix = 2;
    while (
      Object.prototype.hasOwnProperty.call(state.customerSelectionValues, label) &&
      state.customerSelectionOwners[label] !== owner
    ) {
      label = baseLabel + ' ' + suffix;
      suffix += 1;
    }
    if (!Object.prototype.hasOwnProperty.call(state.customerSelectionValues, label)) {
      if (state.customerSelectionOrder.length >= 80) return;
      state.customerSelectionOrder.push(label);
    }
    state.customerSelectionValues[label] = value;
    state.customerSelectionNames[label] = fieldName;
    state.customerSelectionOwners[label] = owner;
  }

  function customizationValues() {
    var values = {};
    state.customerSelectionOrder.slice(0, 80).forEach(function (label) {
      var value = clean(state.customerSelectionValues[label], 500);
      if (!meaningfulValue(value)) return;
      var uniqueLabel = label;
      var suffix = 2;
      while (Object.prototype.hasOwnProperty.call(values, uniqueLabel)) {
        uniqueLabel = label + ' ' + suffix;
        suffix += 1;
      }
      if (Object.keys(values).length < 40) values[uniqueLabel] = value;
    });
    return values;
  }

  function refreshRememberedSelections() {
    var rememberedNames = {};
    Object.keys(state.customerSelectionNames).forEach(function (label) {
      var name = state.customerSelectionNames[label];
      if (name) rememberedNames[name] = true;
    });
    fields().forEach(function (field) {
      if (rememberedNames[normalizedName(field)]) rememberCustomerSelection(field, field);
    });
  }

  function lineItemProperties() {
    var output = {};
    fields().forEach(function (field) {
      var label = propertyLabel(field);
      if (!label || Object.keys(output).length >= 80) return;
      var value = field.type === 'hidden' ? clean(field.value, 2048) : displaySelection(field, field).value;
      if (field.type === 'checkbox' && field.checked && isBackEngravingLabel(label)) value = 'Selected';
      if (!meaningfulValue(value)) return;
      // A multi-pet Customily product can repeat the same dynamic label for
      // several pet slots (for example `P-R Dog Breeds`). An object assignment
      // used to overwrite the earlier pet and made one final breed look as if
      // it belonged to every matching slot. Preserve DOM order with a stable
      // suffix so the ingest Worker can map each value back to its own pet.
      var uniqueLabel = label;
      var suffix = 2;
      while (Object.prototype.hasOwnProperty.call(output, uniqueLabel)) {
        uniqueLabel = label + ' ' + suffix;
        suffix += 1;
      }
      output[uniqueLabel] = clean(value, 2048);
    });
    if (!backEngravingSelectedInDom()) {
      Object.keys(output).forEach(function (label) {
        if (isBackEngravingLabel(label) || isBackMessageLabel(label)) delete output[label];
      });
    }
    return output;
  }

  function materialFromTarget(target) {
    if (!target) return '';
    var nodes = [target];
    if (target.closest) {
      nodes.push(target.closest('label[data-option-name*="material" i], label, [data-option-name*="material" i]'));
    }
    for (var nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) {
      var node = nodes[nodeIndex];
      if (!node) continue;
      var candidates = [
        node.getAttribute && node.getAttribute('data-option-value'),
        node.value,
        node.getAttribute && node.getAttribute('value'),
        node.getAttribute && node.getAttribute('aria-label'),
        node.textContent
      ];
      for (var candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
        var canonical = canonicalMaterial(candidates[candidateIndex]);
        if (canonical) return canonical;
      }
    }
    return '';
  }

  function materialFromDom() {
    var candidates = Array.prototype.slice.call(document.querySelectorAll(
      'input[name="Material"]:checked, select[name="Material"], ' +
      'input[name="options[Material]"]:checked, select[name="options[Material]"], ' +
      'input[name*="material" i]:checked, select[name*="material" i], ' +
      '[data-option-name="Material" i] input:checked, [data-option-name="Material" i] select, ' +
      '[data-option-name*="material" i][aria-selected="true"], ' +
      '[data-option-name*="material" i][aria-checked="true"], ' +
      '.product-form__input--option-material input:checked, .product-form__input--option-material select'
    ));
    for (var index = 0; index < candidates.length; index += 1) {
      var value = materialFromTarget(candidates[index]);
      if (value) {
        state.lastMaterial = value;
        return value;
      }
    }
    return state.lastMaterial;
  }

  // Pawbond uses a two-level breed control: the numbered field stores the
  // alphabet library (for example `A Dog Breeds`) while the following dynamic
  // line-item property stores the exact breed. Other Customily layouts use
  // different shapes, so keep this recovery strictly scoped to this product.
  function productLayout(handle) {
    if (/^soulyshine-the-pawbond-girl-pet-charm-(?:necklace|bracelet)/i.test(handle)) return 'pawbond_multi_charm';
    if (/personalized-pet-companion-charm-only/i.test(handle)) return 'single_pet_breed_pose';
    if (/sleeping-angel-personalized-pet-necklace|angle-dog-personalized-pet-necklace/i.test(handle)) return 'single_pet_dynamic_breed';
    return 'numbered_pet_dynamic_breed';
  }

  function applyPawbondBreedLayoutValues(values, properties, selectedBreedSlots) {
    if (productLayout(productHandle()) !== 'pawbond_multi_charm') return values;
    var selectedSlots = {};
    (selectedBreedSlots || []).forEach(function (slot) {
      selectedSlots[String(slot)] = true;
    });
    var resolvedBreeds = {};
    // Keep only field-level evidence. Earlier versions retained old
    // `Choose breed #N` values and then added a second `Breed #N`, which made
    // Customily's Affenpinscher default look like a customer choice.
    Object.keys(values).forEach(function (label) {
      if (!/breed/i.test(label)) return;
      var slot = breedSlotFromLabel(label);
      var value = clean(values[label], 500);
      if (slot && selectedSlots[String(slot)] && meaningfulValue(value) &&
          !isBreedMenuValue(value) && !opaqueCustomilyAssetId(value)) {
        resolvedBreeds[String(slot)] = value;
      }
      delete values[label];
    });
    var entries = Object.keys(properties || {}).map(function (label) {
      return { label: canonicalLabel(label), value: clean(properties[label], 500) };
    }).filter(function (item) {
      return item.label && meaningfulValue(item.value) && !/^_customily/i.test(item.label);
    });
    var activeSlots = {};
    entries.forEach(function (item) {
      var match = item.label.match(/^Choose Charm #\s*(\d+)$/i);
      if (match && /^(?:Dog|Cat)$/i.test(item.value)) activeSlots[match[1]] = item.value.toLowerCase();
    });
    var menuUsage = {};
    entries.forEach(function (item) {
      var match = item.label.match(/^Choose (Dog|Cat) Breed #\s*(\d+)$/i);
      if (!match || activeSlots[match[2]] !== match[1].toLowerCase() || opaqueCustomilyAssetId(item.value)) return;
      if (!isBreedMenuValue(item.value)) {
        if (selectedSlots[match[2]] && !resolvedBreeds[match[2]]) resolvedBreeds[match[2]] = item.value;
        return;
      }
      var menuKey = item.value.toLowerCase();
      var candidates = entries.filter(function (candidate) {
        var labelKey = candidate.label.toLowerCase();
        return (labelKey === menuKey || labelKey.replace(/\s+\d+$/, '') === menuKey) &&
          !isBreedMenuValue(candidate.value) && !opaqueCustomilyAssetId(candidate.value);
      });
      var candidateIndex = menuUsage[menuKey] || 0;
      menuUsage[menuKey] = candidateIndex + 1;
      if (selectedSlots[match[2]] && !resolvedBreeds[match[2]] && candidates[candidateIndex]) {
        resolvedBreeds[match[2]] = candidates[candidateIndex].value;
      }
    });
    Object.keys(activeSlots).forEach(function (slot) {
      var committedBreed = resolvedBreeds[slot];
      if (!committedBreed) {
        var matchingSelector = entries.find(function (item) {
          return new RegExp('^Choose (?:Dog|Cat) Breed #\\s*' + slot + '$', 'i').test(item.label);
        });
        if (matchingSelector && !isBreedMenuValue(matchingSelector.value)) committedBreed = matchingSelector.value;
        if (matchingSelector && isBreedMenuValue(matchingSelector.value)) {
          var menuKey = matchingSelector.value.toLowerCase();
          var sameMenuSelectors = entries.filter(function (item) {
            return /^Choose (?:Dog|Cat) Breed #\s*\d+$/i.test(item.label) && item.value.toLowerCase() === menuKey;
          });
          var selectorIndex = sameMenuSelectors.indexOf(matchingSelector);
          var candidates = entries.filter(function (candidate) {
            return candidate.label.toLowerCase().replace(/\s+\d+$/, '') === menuKey &&
              !isBreedMenuValue(candidate.value) && !opaqueCustomilyAssetId(candidate.value);
          });
          if (selectorIndex >= 0 && candidates[selectorIndex]) committedBreed = candidates[selectorIndex].value;
        }
      }
      // Affenpinscher is the Customily default on several generic Pawbond
      // controls. Keep it excluded unless the tracker proves the customer
      // actually selected that numbered slot. Other completed line-item breeds
      // can be recovered after the customer commits Preview/Add to cart.
      if (!committedBreed || (/^Affenpinscher$/i.test(committedBreed) && !selectedSlots[slot])) return;
      resolvedBreeds[slot] = committedBreed;
    });
    Object.keys(resolvedBreeds).sort(function (left, right) { return Number(left) - Number(right); }).forEach(function (slot) {
      if (!resolvedBreeds[slot]) return;
      // The evidence marker remains in raw D1 only. The dashboard strips it
      // before rendering and uses it to distinguish a trusted interaction from
      // a Customily default during historical normalization.
      values['Breed evidence #' + slot] = selectedSlots[slot] ? 'customer_interaction' : 'committed_line_item';
      values['Breed #' + slot] = resolvedBreeds[slot];
    });
    return values;
  }

  // Product-layout adapters stay explicit by handle. Soulyshine products use
  // different Customily option-set structures, so a rule that is correct for
  // one layout must not infer values for another layout.
  function applyProductLayoutValues(values, properties) {
    var layout = productLayout(productHandle());
    if (layout !== 'single_pet_dynamic_breed' && layout !== 'single_pet_breed_pose') return values;
    var entries = Object.keys(properties || {}).map(function (label) {
      return { label: canonicalLabel(label), value: clean(properties[label], 500) };
    }).filter(function (item) {
      return item.label && meaningfulValue(item.value) && !/^_customily/i.test(item.label);
    });
    var typeEntry = entries.find(function (item) {
      return /^Choose (?:Your )?Pet$/i.test(item.label) && /^(?:Dog|Cat)$/i.test(item.value);
    });
    var selectorEntry = entries.find(function (item) {
      return /^Choose (?:A )?(?:Dog|Cat) Breed$/i.test(item.label) && isBreedMenuValue(item.value);
    });
    // The selector must also exist in customerSelectionValues. This proves the
    // customer interacted with the breed control and prevents its Customily
    // default from entering Insights.
    var selectorWasChosen = selectorEntry && Object.keys(values).some(function (label) {
      return canonicalLabel(label).toLowerCase() === selectorEntry.label.toLowerCase() &&
        clean(values[label], 500).toLowerCase() === selectorEntry.value.toLowerCase();
    });
    if (!selectorEntry) return values;
    var menuKey = selectorEntry.value.toLowerCase();
    var breedEntry = entries.find(function (item) {
      return item.label.toLowerCase().replace(/\s+\d+$/, '') === menuKey &&
        !isBreedMenuValue(item.value) && !opaqueCustomilyAssetId(item.value);
    });
    if (!breedEntry || (!selectorWasChosen && /^Affenpinscher$/i.test(breedEntry.value))) return values;
    Object.keys(values).forEach(function (label) {
      if (/breed/i.test(canonicalLabel(label)) && !/breed\s*(?:design|style|variant|version|number)/i.test(label)) delete values[label];
    });
    values['Choose Pet #1'] = typeEntry ? typeEntry.value : 'Dog';
    values['Breed evidence #1'] = selectorWasChosen ? 'customer_interaction' : 'committed_line_item';
    values['Breed #1'] = breedEntry.value;
    if (layout === 'single_pet_breed_pose') {
      var poseEntry = entries.find(function (item) {
        return item.label.toLowerCase().replace(/\s+\d+$/, '') === breedEntry.value.toLowerCase() &&
          item.value.toLowerCase() !== breedEntry.value.toLowerCase();
      });
      if (poseEntry) values['Breed design #1'] = poseEntry.value;
    }
    return values;
  }

  function snapshotSelectionSignature(data) {
    var values = data && data.customizationValues && typeof data.customizationValues === 'object'
      ? data.customizationValues : {};
    return Object.keys(values).filter(function (label) {
      var value = clean(values[label], 500);
      return label && value && !/^_customily/i.test(label) && !/^https:\/\//i.test(value) &&
        !/breed evidence/i.test(label) && !/variant sold out or unavailable/i.test(label);
    }).map(function (label) {
      return canonicalLabel(label).toLowerCase() + '=' + clean(values[label], 500).toLowerCase();
    }).sort().join('|');
  }

  function committedCustomizationValues(properties, material) {
    var values = customizationValues();
    if (!backEngravingSelectedInDom()) {
      Object.keys(values).forEach(function (label) {
        if (isBackEngravingLabel(label) || isBackMessageLabel(label)) delete values[label];
      });
    }
    // Customily often serializes the final breed under a dynamic library label
    // (for example `P-R Dog Breeds`) rather than the numbered control the
    // customer clicked. Keep a slot only when that numbered control has an
    // explicit customer interaction; this preserves the no-default-breeds
    // rule while allowing the final Customily value to reach Insights.
    var selectedBreedSlots = Object.keys(state.customerSelectionOwners).map(function (label) {
      var owner = state.customerSelectionOwners[label] || '';
      // Both a direct exact-breed choice and the library selector represent an
      // explicit customer interaction. The latter gets its exact value from
      // Customily's live dynamic hidden property, in DOM order below.
      var match = owner.match(/^breed-(?:choice|group)\|(\d+)$/);
      var value = clean(state.customerSelectionValues[label], 500);
      return match && meaningfulValue(value) && !opaqueCustomilyAssetId(value) ? Number(match[1]) : 0;
    }).filter(function (slot, index, list) {
      return slot > 0 && list.indexOf(slot) === index;
    }).sort(function (left, right) { return left - right; });
    var fallbackBreedIndex = 0;
    Object.keys(properties || {}).forEach(function (label) {
      if (/^_customily/i.test(label)) return;
      var value = clean(properties[label], 500);
      if (!meaningfulValue(value)) return;
      var normalized = canonicalLabel(label).toLowerCase();
      var isBreed = /breed/i.test(label);
      var breedWasChosen = Object.keys(values).some(function (existing) {
        return /breed/i.test(existing) && canonicalLabel(existing).toLowerCase() === normalized;
      });
      // Preserve the customer-selected-only rule for breeds. Other current form
      // values become committed evidence only when Preview/Add to cart is clicked.
      if (isBreed && !breedWasChosen) {
        var propertySlot = breedSlotFromLabel(label);
        // Dynamic Customily library labels normally have no slot. Their order in
        // the line-item properties is the same order as the customer-selected
        // breed controls, so map only the next explicitly interacted slot.
        if (!propertySlot && !/breed\s*(?:design|style|variant|version|number)/i.test(label)) {
          propertySlot = selectedBreedSlots[fallbackBreedIndex] || 0;
          fallbackBreedIndex += 1;
        }
        if (!propertySlot || selectedBreedSlots.indexOf(propertySlot) === -1 || opaqueCustomilyAssetId(value)) return;
        values['Breed #' + propertySlot] = value;
        return;
      }
      Object.keys(values).forEach(function (existing) {
        var existingNormalized = canonicalLabel(existing).toLowerCase().replace(/\s+\d+$/, '');
        if (existingNormalized === normalized) delete values[existing];
      });
      values[canonicalLabel(label)] = value;
    });
    if (material) values.Material = material;
    values = applyPawbondBreedLayoutValues(values, properties, selectedBreedSlots);
    return applyProductLayoutValues(values, properties);
  }

  function selectedValue(nameTests, valueTest) {
    for (var index = 0; index < state.customerSelectionOrder.length; index += 1) {
      var label = state.customerSelectionOrder[index];
      var fieldName = state.customerSelectionNames[label] || '';
      if (!nameTests.some(function (test) { return test.test(label.toLowerCase()) || test.test(fieldName); })) continue;
      var value = clean(state.customerSelectionValues[label], 500);
      if (meaningfulValue(value) && (!valueTest || valueTest(value))) return value;
    }
    return '';
  }

  function httpsUrl(value) {
    var cleaned = clean(value, 2048);
    return /^https:\/\//i.test(cleaned) ? cleaned : '';
  }

  function isVerifiedPersonalizationUrl(value) {
    var candidate = httpsUrl(value);
    if (!candidate) return false;
    try {
      var hostname = new URL(candidate).hostname.toLowerCase();
      return hostname === 'cdn.customily.com' || /\.customily\.com$/i.test(hostname);
    } catch (_error) {
      return false;
    }
  }

  function exactCustomilyPreviewUrlFromProperties(properties) {
    var previewUrl = '';
    Object.keys(properties || {}).some(function (rawLabel) {
      var label = clean(rawLabel, 180).replace(/[\u200B-\u200D\uFEFF]/g, '').toLowerCase();
      if (label !== '_customily-preview') return false;
      var candidate = httpsUrl(properties[rawLabel]);
      previewUrl = isVerifiedPersonalizationUrl(candidate) ? candidate : '';
      return Boolean(previewUrl);
    });
    return previewUrl;
  }

  function customilyPersonalizationIdFromProperties(properties) {
    var personalizationId = '';
    Object.keys(properties || {}).some(function (rawLabel) {
      var label = clean(rawLabel, 180).replace(/[\u200B-\u200D\uFEFF]/g, '').toLowerCase();
      if (label !== '_customily-personalization-id') return false;
      personalizationId = clean(properties[rawLabel], 180);
      return Boolean(personalizationId);
    });
    return personalizationId;
  }

  function normalizedCustomilyId(value) {
    var cleanValue = clean(value, 180);
    var uuid = cleanValue.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);
    return uuid ? uuid[0].toLowerCase() : cleanValue.toLowerCase();
  }

  function customilyPreviewUrlFromProperties(properties) {
    // Product-agnostic contract: `_customily-thumb` is an option/product image,
    // never evidence of the customer's finished personalization.
    return exactCustomilyPreviewUrlFromProperties(properties);
  }

  function syncExactCustomilyPreview(snapshot, eventName, reason) {
    if (!trackingAllowed() || !snapshot || !snapshot.id) return;
    var currentData = personalizationData();
    if (snapshot.selectionSignature && snapshotSelectionSignature(currentData) !== snapshot.selectionSignature) return;
    var currentLineItems = lineItemProperties();
    var exactPreviewUrl = exactCustomilyPreviewUrlFromProperties(currentLineItems);
    if (!exactPreviewUrl || state.previewUrlSyncs[snapshot.id] === exactPreviewUrl) return;
    state.previewUrlSyncs[snapshot.id] = exactPreviewUrl;
    uploadPreviewSnapshot(snapshot.id, exactPreviewUrl).then(function (uploaded) {
      publish(eventName, {
        trigger: reason,
        snapshotAction: snapshot.action,
        customizationSnapshotId: snapshot.id,
        snapshotSequence: snapshot.sequence,
        previewObjectKey: uploaded && uploaded.objectKey ? uploaded.objectKey : undefined,
        previewContentType: uploaded && uploaded.contentType ? uploaded.contentType : undefined,
        previewUrl: exactPreviewUrl,
        lineItemProperties: currentLineItems,
        previewCaptureStatus: uploaded ? 'archived_r2' : 'ready'
      }, true, currentData);
    });
  }

  function scheduleExactCustomilyPreviewSync(snapshot, eventName) {
    [450, 1100, 2200, 3500, 6000, 10000, 16000, 25000].forEach(function (delay) {
      deferTracking('customily_preview_url_' + delay + 'ms', function () {
        syncExactCustomilyPreview(snapshot, eventName, snapshot.action + '_customily_preview_' + delay + 'ms');
      }, delay);
    });
  }

  function previewObjectKey(snapshotId) {
    return snapshotId ? 'previews/snapshots/' + snapshotId + '.webp' : '';
  }

  function previewImageSources() {
    var sources = [];
    function add(source) {
      if (!source || sources.indexOf(source) >= 0) return;
      var width = source.naturalWidth || source.width || 0;
      var height = source.naturalHeight || source.height || 0;
      if (width > 0 && height > 0) sources.push(source);
    }

    // Customily's Fabric canvas can be tainted by cross-origin swatches. Its
    // active canvas thumbnail is a data URL generated by Customily itself and
    // is therefore the safest exact personalization source. Try images first,
    // then retain the canvas as a fallback for products that do not expose the
    // generated thumbnail.
    var images = document.querySelectorAll(
      '.customily_gallery_thumbnail.active.canvas-thumbnail img, .customily_gallery_media img[data-customily-preview], .customily_gallery img[data-customily-preview]'
    );
    for (var imageIndex = 0; imageIndex < images.length; imageIndex += 1) {
      var source = String(images[imageIndex].currentSrc || images[imageIndex].src || '');
      if (/^(?:data:image\/|blob:)/i.test(source) || isVerifiedPersonalizationUrl(source)) add(images[imageIndex]);
    }

    var canvases = document.querySelectorAll(
      '#preview-canvas.lower-canvas, canvas#preview-canvas, .customily_gallery_media canvas, .customily_gallery .canvas-container canvas'
    );
    for (var canvasIndex = 0; canvasIndex < canvases.length; canvasIndex += 1) {
      add(canvases[canvasIndex]);
    }
    return sources;
  }

  function previewImageSource() {
    return previewImageSources()[0] || null;
  }

  function previewFingerprint(source) {
    if (!source) return '';
    // Do not normalize the complete data URL: Customily previews can be several
    // megabytes and scanning that string would violate the storefront budget.
    var src = String(source.currentSrc || source.src || '');
    if (src) {
      if (/^data:/i.test(src)) {
        var quarter = Math.floor(src.length / 4);
        var middle = Math.floor(src.length / 2);
        var threeQuarter = Math.floor(src.length * 3 / 4);
        return 'data:' + src.length + ':' +
          src.slice(quarter, quarter + 48) + ':' +
          src.slice(middle, middle + 48) + ':' +
          src.slice(threeQuarter, threeQuarter + 48);
      }
      return 'src:' + clean(src, 2048);
    }
    return 'canvas:' + clean(source.id, 80) + ':' + clean(source.className, 120) + ':' +
      (source.width || 0) + 'x' + (source.height || 0);
  }

  function renderedPreviewHasContent(canvas) {
    // Reject a transparent/solid-white Customily frame. This is intentionally
    // sampled at 24x24 so the check stays below the storefront performance
    // budget while still detecting the centered jewelry/pet artwork.
    var probe = document.createElement('canvas');
    probe.width = 24;
    probe.height = 24;
    var context = probe.getContext('2d', { alpha: true, willReadFrequently: true });
    if (!context) return false;
    try {
      context.drawImage(canvas, 0, 0, probe.width, probe.height);
      var pixels = context.getImageData(0, 0, probe.width, probe.height).data;
      var corners = [0, 23, 552, 575];
      var background = [0, 0, 0, 0];
      corners.forEach(function (pixelIndex) {
        var offset = pixelIndex * 4;
        background[0] += pixels[offset];
        background[1] += pixels[offset + 1];
        background[2] += pixels[offset + 2];
        background[3] += pixels[offset + 3];
      });
      background = background.map(function (value) { return value / corners.length; });
      var visible = 0;
      var different = 0;
      for (var index = 0; index < pixels.length; index += 4) {
        var alpha = pixels[index + 3];
        if (alpha > 12) visible += 1;
        var distance = Math.abs(pixels[index] - background[0]) +
          Math.abs(pixels[index + 1] - background[1]) +
          Math.abs(pixels[index + 2] - background[2]) +
          Math.abs(alpha - background[3]);
        if (distance > 30) different += 1;
      }
      return visible >= 3 && different >= 2;
    } catch (_error) {
      return false;
    }
  }

  function previewBlob(priority) {
    return new Promise(function (resolve) {
      if (!trackingAllowed()) return resolve(null);
      if (Date.now() < state.previewCapturePausedUntil) return resolve(null);
      function renderThumbnail() {
        if (!trackingAllowed()) return resolve(null);
        runBudgeted('preview_thumbnail_300px', function () {
          var sources = previewImageSources();
          function trySource(index) {
            if (!trackingAllowed() || index >= sources.length) return resolve(null);
            var source = sources[index];
            var width = source.naturalWidth || source.width || 0;
            var height = source.naturalHeight || source.height || 0;
            if (!width || !height) return trySource(index + 1);
            var maxSide = 300;
            var scale = Math.min(1, maxSide / Math.max(width, height));
            var canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(width * scale));
            canvas.height = Math.max(1, Math.round(height * scale));
            var context = canvas.getContext('2d', { alpha: true });
            if (!context) return trySource(index + 1);
            try {
              context.drawImage(source, 0, 0, canvas.width, canvas.height);
              if (!renderedPreviewHasContent(canvas)) return trySource(index + 1);
              canvas.toBlob(function (blob) {
                // Safari and a few embedded browsers can fall back to PNG even
                // when WebP is requested. The ingest endpoint accepts these
                // formats and preserves the actual content type, so rejecting
                // the fallback here would silently lose a valid preview.
                if (blob && /^image\/(?:webp|png|jpeg)$/i.test(blob.type || '')) return resolve(blob);
                trySource(index + 1);
              }, 'image/webp', 0.78);
            } catch (_error) {
              trySource(index + 1);
            }
          }
          trySource(0);
        });
      }
      // Normal Preview work is deliberately idle-only. Add to cart may move
      // Customily/cart state before that idle slot runs, so a pointer-down
      // prewarm requests this same 300px canvas conversion on the next task.
      // It still never delays the click or the commerce request.
      if (priority) {
        window.setTimeout(renderThumbnail, 0);
      } else if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(renderThumbnail, { timeout: 1200 });
      } else {
        window.setTimeout(renderThumbnail, 0);
      }
    });
  }

  function prewarmAddToCartPreview() {
    if (!trackingAllowed() || Date.now() < state.previewCapturePausedUntil) return;
    var source = previewImageSource();
    var fingerprint = previewFingerprint(source);
    if (!fingerprint) return;
    var cached = state.prewarmedPreview;
    if (cached && cached.fingerprint === fingerprint && cached.expiresAt > Date.now()) return;
    if (state.prewarmPreviewPromise) return;
    state.prewarmPreviewPromise = previewBlob(true).then(function (blob) {
      if (blob) {
        state.prewarmedPreview = {
          blob: blob,
          fingerprint: fingerprint,
          expiresAt: Date.now() + 15000
        };
      }
      state.prewarmPreviewPromise = null;
      return blob;
    }, function () {
      state.prewarmPreviewPromise = null;
      return null;
    });
  }

  function prewarmedPreviewBlob() {
    var cached = state.prewarmedPreview;
    if (!cached || cached.expiresAt <= Date.now()) return null;
    if (cached.fingerprint !== previewFingerprint(previewImageSource())) return null;
    return cached.blob || null;
  }

  function previewBlobFromUrl(previewUrl) {
    return new Promise(function (resolve) {
      if (!trackingAllowed() || !isVerifiedPersonalizationUrl(previewUrl) || typeof window.fetch !== 'function') return resolve(null);
      var controller = typeof window.AbortController === 'function' ? new AbortController() : null;
      var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 4500);
      fetch(previewUrl, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('preview_download_failed');
        var declaredSize = Number(response.headers.get('Content-Length') || 0);
        if (declaredSize > 5000000) throw new Error('preview_too_large');
        return response.blob();
      }).then(function (sourceBlob) {
        if (!sourceBlob || !/^image\//i.test(sourceBlob.type || '') || sourceBlob.size > 5000000) return null;
        if (typeof window.createImageBitmap !== 'function') return null;
        return window.createImageBitmap(sourceBlob).then(function (bitmap) {
          var width = bitmap.width || 0;
          var height = bitmap.height || 0;
          if (!width || !height) {
            bitmap.close();
            return null;
          }
          var scale = Math.min(1, 300 / Math.max(width, height));
          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(width * scale));
          canvas.height = Math.max(1, Math.round(height * scale));
          var context = canvas.getContext('2d', { alpha: true });
          if (!context) {
            bitmap.close();
            return null;
          }
          context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
          bitmap.close();
          if (!renderedPreviewHasContent(canvas)) return null;
          return new Promise(function (blobResolve) {
            canvas.toBlob(function (thumbnail) {
              blobResolve(thumbnail && /^image\/(?:webp|png|jpeg)$/i.test(thumbnail.type || '') ? thumbnail : null);
            }, 'image/webp', 0.78);
          });
        });
      }).then(function (thumbnail) {
        window.clearTimeout(timer);
        resolve(thumbnail || null);
      }).catch(function () {
        window.clearTimeout(timer);
        resolve(null);
      });
    });
  }

  function rawCustomilyDataPreviewBlob() {
    // Last-resort fallback for Customily layouts whose generated thumbnail is
    // a valid data image but cannot be redrawn through canvas in a particular
    // browser. Successful 300px conversion remains the first choice; this path
    // runs only after it fails and never touches Customily or commerce state.
    var image = document.querySelector('.customily_gallery_thumbnail.active.canvas-thumbnail img');
    var source = image && String(image.currentSrc || image.src || '');
    if (!/^data:image\/(?:png|jpeg|webp);base64,/i.test(source) || source.length > 1900000 || typeof window.fetch !== 'function') {
      return Promise.resolve(null);
    }
    return fetch(source).then(function (response) { return response.blob(); }).then(function (blob) {
      return blob && blob.size > 0 && blob.size <= 1500000 && /^image\/(?:png|jpeg|webp)$/i.test(blob.type || '') ? blob : null;
    }).catch(function () { return null; });
  }

  function uploadPreviewSnapshot(snapshotId, preferredPreviewUrl) {
    if (!trackingAllowed() || !snapshotId) return Promise.resolve(null);
    if (state.previewUploads[snapshotId]) return state.previewUploads[snapshotId];
    var uploadAttempt = Promise.resolve(prewarmedPreviewBlob()).then(function (blob) {
      if (blob) return blob;
      return previewBlob();
    }).then(function (blob) {
      if (blob) return blob;
      return rawCustomilyDataPreviewBlob();
    }).then(function (blob) {
      if (blob) return blob;
      return previewBlobFromUrl(preferredPreviewUrl || previewUrlFromDom());
    }).then(function (blob) {
      if (!trackingAllowed() || !blob) return null;
      return fetch(previewUploadEndpoint + encodeURIComponent(snapshotId), {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        // Preserve PNG/JPEG fallbacks from browsers that cannot encode WebP.
        // The Worker validates this header before writing the 300px thumbnail.
        headers: { 'Content-Type': /^image\/(?:webp|png|jpeg)$/i.test(blob.type || '') ? blob.type : 'image/webp' },
        body: blob,
        keepalive: blob.size <= 64000
      }).then(function (response) {
        if (!response.ok) return null;
        return response.json().then(function (data) {
          return data && data.objectKey ? data : null;
        });
      });
    }).catch(function () { return null; });
    state.previewUploads[snapshotId] = uploadAttempt;
    return uploadAttempt.then(function (uploaded) {
      // Customily often renders the preview asynchronously. A first attempt can
      // legitimately find an empty/not-yet-sized canvas, so only cache success.
      // Clearing a null result lets the scheduled 450/1100/2200/3500ms attempts
      // capture the finished preview without blocking the Preview or ATC action.
      if (!uploaded && state.previewUploads[snapshotId] === uploadAttempt) {
        delete state.previewUploads[snapshotId];
      }
      return uploaded;
    });
  }

  function previewUrlFromDom() {
    var exactLineItemUrl = customilyPreviewUrlFromProperties(lineItemProperties());
    if (exactLineItemUrl) return exactLineItemUrl;
    var hiddenUrl = httpsUrl(findValue([
      /_customily.*(?:thumb|preview)/,
      /properties\[.*(?:thumb|preview)/,
      /(?:thumb|preview).*(?:customily|personalization)/
    ]));
    if (isVerifiedPersonalizationUrl(hiddenUrl)) return hiddenUrl;
    // Some Customily products expose a rendered CDN preview in the gallery;
    // accept it only when it is hosted by Customily. Shopify CDN images can be
    // main product media, option art, upload inputs, or swatches.
    var activePreview = document.querySelector(
      '.customily_gallery_thumbnail.active img, .customily_gallery_media img[data-customily-preview]'
    );
    var activePreviewUrl = activePreview && httpsUrl(activePreview.currentSrc || activePreview.src);
    if (isVerifiedPersonalizationUrl(activePreviewUrl)) return activePreviewUrl;
    var images = Array.prototype.slice.call(document.querySelectorAll(
      '.customily_gallery_media img, .customily_gallery img, img[data-customily-preview], [data-customily-preview] img'
    )).filter(function (image) {
      return !image.closest('#customily-options, .customily-options-wrapper, .customily-option, .customily-option-group, [class*="thumbnail"], [class*="swatch"]');
    }).sort(function (left, right) {
      var leftArea = (left.naturalWidth || left.width || 0) * (left.naturalHeight || left.height || 0);
      var rightArea = (right.naturalWidth || right.width || 0) * (right.naturalHeight || right.height || 0);
      return rightArea - leftArea;
    });
    for (var index = 0; index < images.length; index += 1) {
      var candidate = httpsUrl(images[index].currentSrc || images[index].src);
      if (isVerifiedPersonalizationUrl(candidate)) return candidate;
    }
    return isVerifiedPersonalizationUrl(state.lastPreviewUrl) ? state.lastPreviewUrl : '';
  }

  function findValue(nameTests, valueTest) {
    var list = fields();
    for (var index = 0; index < list.length; index += 1) {
      var field = list[index];
      var name = normalizedName(field);
      var matchesName = nameTests.some(function (test) { return test.test(name); });
      if (!matchesName) continue;
      var value = displayValue(field);
      if (meaningfulValue(value) && (!valueTest || valueTest(value))) return value;
    }
    return '';
  }

  function productHandle() {
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? clean(match[1], 180) : '';
  }

  function personalizationData() {
    ensureSelectionProductContext();
    refreshRememberedSelections();
    // This record contains only values observed from a trusted customer
    // change/input/click. Keep it separate from committedCustomizationValues,
    // which intentionally also snapshots current non-breed form values at
    // Preview/Add to cart for Activity Log and Customer Graph completeness.
    // Business Intelligence can therefore require exact field + value proof
    // without changing the existing committed snapshot contract.
    var fieldValueEvidence = customizationValues();
    var breed = selectedValue(
      [/breed/, /dog breeds/, /cat breeds/],
      function (value) { return !/^[a-z](?:-[a-z])?\s+(?:dog|cat)\s+breeds$/i.test(value); }
    );
    var material = materialFromDom() || selectedValue([/^material$/, /options\[material\]/, /properties\[material\]/]);
    var petName = selectedValue([/pet'?s? name/, /dog'?s? name/, /cat'?s? name/]);
    var petType = selectedValue([/choose pet(?:\s*#?\d+)?\]/, /pet type/]);
    var engraving = selectedValue([/engrav/]);
    var customizationId = findValue([/_customily.*(?:customization|id)/]);
    var personalizationId = findValue([/_customily.*personalization/]);
    var previewUrl = previewUrlFromDom();
    var properties = lineItemProperties();
    if (material && !Object.keys(properties).some(function (label) { return /^material$/i.test(label); })) {
      properties.Material = material;
    }
    var optionValues = committedCustomizationValues(properties, material);
    if (previewUrl) state.lastPreviewUrl = previewUrl;

    var data = {
      productHandle: productHandle(),
      breed: breed,
      petName: petName,
      petType: petType,
      material: material,
      engraving: engraving ? 'yes' : '',
      customizationId: customizationId,
      personalizationId: personalizationId,
      previewUrl: previewUrl,
      customizationValues: Object.keys(optionValues).length ? optionValues : undefined,
      selectionEvidence: Object.keys(optionValues).length ? 'customer_interaction' : undefined,
      customerSelectedKeys: Object.keys(optionValues).length ? Object.keys(optionValues) : undefined,
      fieldValueEvidence: Object.keys(fieldValueEvidence).length ? fieldValueEvidence : undefined,
      lineItemProperties: Object.keys(properties).length ? properties : undefined
    };
    Object.keys(data).forEach(function (key) {
      if (!data[key]) delete data[key];
    });
    return data;
  }

  function publish(eventName, extra, allowDuplicate, actionSnapshot) {
    if (!trackingAllowed()) return false;
    // Customer-selected values are evidence only when the customer explicitly
    // commits them with Preview or Add to cart. All other lifecycle events keep
    // a minimal product context and cannot contribute customization demand.
    var data = Object.assign(
      {},
      actionSnapshot || { productHandle: productHandle() },
      extra || {}
    );
    var signature = JSON.stringify(data);
    if (!allowDuplicate && state.lastPayloads[eventName] === signature) return true;
    state.lastPayloads[eventName] = signature;
    // The direct first-party request and Shopify custom pixel copy share this
    // explicit ID so the Worker can safely deduplicate the two delivery paths.
    data.bridgeEventId = clean(data.bridgeEventId, 180) || randomId('sse_');
    var firstPartyAccepted = sendFirstPartyEvent(eventName, data);
    if (!analyticsProcessingAllowed()) return firstPartyAccepted;
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return firstPartyAccepted;
    try {
      var result = Shopify.analytics.publish('soulyshine_' + eventName, data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return true;
    } catch (_error) {
      return firstPartyAccepted;
    }
  }

  function ensureStarted(reason) {
    if (!trackingAllowed() || state.started) return;
    state.started = true;
    publish('customization_started', { trigger: clean(reason, 64) });
  }

  function scheduleChanged(reason) {
    if (!trackingAllowed()) return;
    ensureStarted(reason);
    window.clearTimeout(state.changeTimer);
    state.changeTimer = deferTracking('customization_changed', function () {
      publish('customization_changed', { trigger: clean(reason, 64) }, true);
      detectSaved();
    }, 450);
  }

  function detectSaved() {
    if (!trackingAllowed() || state.saved) return;
    var data = personalizationData();
    if (!data.customizationId && !data.personalizationId) return;
    state.saved = true;
    publish('customization_saved');
  }

  function newSnapshotId(action) {
    state.snapshotSequence += 1;
    return 'sscs_' + action + '_' + Date.now().toString(36) + '_' + state.snapshotSequence;
  }

  async function markPreviewCreated(reason, cycle, force) {
    if (!trackingAllowed()) return;
    var targetCycle = cycle || state.previewCycle;
    if (!targetCycle || state.previewCompletedCycles[targetCycle] || state.previewCompletingCycles[targetCycle] || !state.started) return;
    var snapshot = state.previewSnapshots[targetCycle];
    if (!snapshot) return;
    var currentActionData = personalizationData();
    if (snapshot.selectionSignature && snapshotSelectionSignature(currentActionData) !== snapshot.selectionSignature) {
      // The design changed after the click. Dropping this old snapshot is safer
      // than pairing a later Customily image with earlier Insights.
      state.previewCompletedCycles[targetCycle] = true;
      delete state.previewSnapshots[targetCycle];
      return;
    }
    var currentLineItems = lineItemProperties();
    var exactPreviewUrl = exactCustomilyPreviewUrlFromProperties(currentLineItems);
    var currentPreviewUrl = exactPreviewUrl || customilyPreviewUrlFromProperties(currentLineItems) || previewUrlFromDom();
    var currentPreviewSource = previewImageSource();
    var currentFingerprint = previewFingerprint(currentPreviewSource);
    var hasDrawablePreview = Boolean(currentPreviewSource && (
      (currentPreviewSource.naturalWidth || currentPreviewSource.width || 0) > 0 &&
      (currentPreviewSource.naturalHeight || currentPreviewSource.height || 0) > 0
    ));
    var hasUpdatedPreview = Boolean(
      (currentPreviewUrl && currentPreviewUrl !== snapshot.beforeUrl) ||
      (currentFingerprint && currentFingerprint !== snapshot.beforeFingerprint)
    );
    // Customily renders the selected design live before the customer presses
    // Preview; the click often only opens the modal. A drawable canvas/image at
    // click time is therefore the correct customer preview even when its
    // fingerprint does not change after the click.
    var shouldArchive = hasDrawablePreview || Boolean(currentPreviewUrl);
    if (!force && !shouldArchive) return;
    state.previewCompletingCycles[targetCycle] = true;
    var uploaded = shouldArchive ? await uploadPreviewSnapshot(snapshot.id, currentPreviewUrl) : null;
    // A public Customily URL is sometimes written while the idle thumbnail
    // capture is running. Re-read it before deciding the attempt failed.
    currentLineItems = lineItemProperties();
    exactPreviewUrl = exactCustomilyPreviewUrlFromProperties(currentLineItems);
    currentPreviewUrl = exactPreviewUrl || customilyPreviewUrlFromProperties(currentLineItems) || currentPreviewUrl || previewUrlFromDom();
    if (exactPreviewUrl) state.previewUrlSyncs[snapshot.id] = exactPreviewUrl;
    if (!uploaded && currentPreviewUrl && currentPreviewUrl === snapshot.beforeUrl && !hasUpdatedPreview && !hasDrawablePreview) {
      // Never attach a stale URL from an earlier personalization to the new
      // click. R2 can still supply the exact captured image when available.
      currentPreviewUrl = '';
    }
    if (!uploaded && !currentPreviewUrl && !force) {
      delete state.previewCompletingCycles[targetCycle];
      return;
    }
    if (targetCycle === state.previewCycle) {
      state.previewRequested = false;
      stopPreviewObserver();
    }
    state.previewCompletedCycles[targetCycle] = true;
    delete state.previewCompletingCycles[targetCycle];
    state.previewCreatedCycle = Math.max(state.previewCreatedCycle, targetCycle);
    publish('preview_created', {
      trigger: clean(reason, 64),
      snapshotAction: 'preview',
      customizationSnapshotId: snapshot.id,
      snapshotSequence: snapshot.sequence,
      previewObjectKey: uploaded && uploaded.objectKey ? uploaded.objectKey : undefined,
      previewContentType: uploaded && uploaded.contentType ? uploaded.contentType : undefined,
      previewUrl: currentPreviewUrl || undefined,
      lineItemProperties: currentLineItems,
      previewCaptureStatus: uploaded ? 'archived_r2' : currentPreviewUrl ? 'ready' : shouldArchive ? 'capture_failed' : 'missing'
    }, true, currentActionData);
    delete state.previewSnapshots[targetCycle];
    if (state.previewVisible) publish('preview_viewed');
  }

  function publishCartSnapshot(trigger) {
    if (!trackingAllowed()) return;
    var now = Date.now();
    if (now - state.lastAtcSnapshotAt < 1200) return;
    state.lastAtcSnapshotAt = now;
    ensureStarted(trigger);
    var snapshotId = newSnapshotId('add_to_cart');
    var snapshotSequence = state.snapshotSequence;
    var actionData = personalizationData();
    var actionSelectionSignature = snapshotSelectionSignature(actionData);
    savePendingCartSnapshot({
      id: snapshotId,
      sequence: snapshotSequence,
      productHandle: actionData.productHandle || productHandle(),
      actionData: actionData,
      selectionSignature: actionSelectionSignature,
      createdAt: Date.now()
    });
    var archivedPreview = null;
    var lastEmittedPreviewUrl = '';
    function emitCartSnapshot(reason, uploaded) {
      var currentLineItems = lineItemProperties();
      var savedPreviewUrl = customilyPreviewUrlFromProperties(currentLineItems) || previewUrlFromDom();
      if (!uploaded && savedPreviewUrl && savedPreviewUrl === lastEmittedPreviewUrl) return;
      if (savedPreviewUrl) lastEmittedPreviewUrl = savedPreviewUrl;
      // Add to cart can complete after Customily has applied its final dynamic
      // controls. Rebuild the committed selection at emission time so Insights
      // and the archived preview always describe the same final design.
      var finalActionData = personalizationData();
      var finalSignature = snapshotSelectionSignature(finalActionData);
      if (finalActionData && finalActionData.customizationValues &&
          (!actionSelectionSignature || finalSignature === actionSelectionSignature)) actionData = finalActionData;
      savePendingCartSnapshot({
        id: snapshotId,
        sequence: snapshotSequence,
        productHandle: actionData.productHandle || productHandle(),
        actionData: actionData,
        selectionSignature: actionSelectionSignature,
        createdAt: Date.now()
      });
      publish('customization_completed', {
        trigger: reason,
        snapshotAction: 'add_to_cart',
        customizationSnapshotId: snapshotId,
        snapshotSequence: snapshotSequence,
        previewObjectKey: uploaded && uploaded.objectKey ? uploaded.objectKey : undefined,
        previewContentType: uploaded && uploaded.contentType ? uploaded.contentType : undefined,
        previewUrl: savedPreviewUrl || undefined,
        lineItemProperties: currentLineItems,
        previewCaptureStatus: uploaded ? 'archived_r2' : savedPreviewUrl ? 'ready' : 'uploading_r2'
      }, true, actionData);
    }
    function retryCartArchive(reason) {
      if (!trackingAllowed()) return;
      var currentLineItems = lineItemProperties();
      var currentSignature = snapshotSelectionSignature(personalizationData());
      if (actionSelectionSignature && currentSignature && currentSignature !== actionSelectionSignature) return;
      var exactPreviewUrl = exactCustomilyPreviewUrlFromProperties(currentLineItems);
      var currentPreviewUrl = exactPreviewUrl || customilyPreviewUrlFromProperties(currentLineItems) || previewUrlFromDom();
      if (currentPreviewUrl && currentPreviewUrl !== lastEmittedPreviewUrl) {
        emitCartSnapshot(reason + '_customily_url', null);
      }
      if (archivedPreview) return;
      uploadPreviewSnapshot(snapshotId, currentPreviewUrl).then(function (uploaded) {
        if (!uploaded || archivedPreview) return;
        archivedPreview = uploaded;
        emitCartSnapshot(reason, uploaded);
      });
    }
    emitCartSnapshot(trigger, null);
    retryCartArchive(trigger + '_archived');
    deferTracking('cart_archive_450ms', function () { retryCartArchive(trigger + '_450ms'); }, 450);
    deferTracking('cart_archive_1100ms', function () { retryCartArchive(trigger + '_1100ms'); }, 1100);
    deferTracking('cart_archive_2200ms', function () { retryCartArchive(trigger + '_2200ms'); }, 2200);
    deferTracking('cart_archive_3500ms', function () { retryCartArchive(trigger + '_3500ms'); }, 3500);
    deferTracking('cart_archive_6000ms', function () { retryCartArchive(trigger + '_6000ms'); }, 6000);
    deferTracking('cart_archive_10000ms', function () { retryCartArchive(trigger + '_10000ms'); }, 10000);
    deferTracking('cart_archive_16000ms', function () { retryCartArchive(trigger + '_16000ms'); }, 16000);
    deferTracking('cart_archive_final', function () { retryCartArchive(trigger + '_25000ms'); }, 25000);
    schedulePendingCartRecovery('add_to_cart');
    detectSaved();
  }

  function savePendingCartSnapshot(snapshot) {
    try {
      window.sessionStorage.setItem(pendingCartStorageKey, JSON.stringify(snapshot));
    } catch (_error) {}
  }

  function pendingCartSnapshot() {
    try {
      var snapshot = JSON.parse(window.sessionStorage.getItem(pendingCartStorageKey) || 'null');
      if (!snapshot || !snapshot.id || !snapshot.createdAt || Date.now() - Number(snapshot.createdAt) > 10 * 60 * 1000) {
        window.sessionStorage.removeItem(pendingCartStorageKey);
        return null;
      }
      return snapshot;
    } catch (_error) {
      return null;
    }
  }

  function clearPendingCartSnapshot(snapshotId) {
    try {
      var current = pendingCartSnapshot();
      if (!current || current.id === snapshotId) window.sessionStorage.removeItem(pendingCartStorageKey);
    } catch (_error) {}
  }

  function cartItemHandle(item) {
    var direct = clean(item && (item.handle || item.product_handle), 180);
    if (direct) return direct;
    var match = clean(item && item.url, 2048).match(/\/products\/([^/?#]+)/i);
    return match ? clean(match[1], 180) : '';
  }

  function recoverPendingCartPreview(reason) {
    if (!trackingAllowed() || state.pendingCartRecovery || typeof window.fetch !== 'function') return;
    var snapshot = pendingCartSnapshot();
    if (!snapshot) return;
    state.pendingCartRecovery = true;
    fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_snapshot_unavailable');
      return response.json();
    }).then(function (cart) {
      var items = cart && Array.isArray(cart.items) ? cart.items : [];
      var expectedPersonalizationId = normalizedCustomilyId(snapshot.actionData && snapshot.actionData.personalizationId);
      var matches = items.filter(function (item) {
        return !snapshot.productHandle || cartItemHandle(item) === snapshot.productHandle;
      });
      var candidates = matches.length ? matches : items;
      var item = candidates.slice().sort(function (left, right) {
        function score(candidate) {
          var candidateProperties = candidate && candidate.properties && typeof candidate.properties === 'object' ? candidate.properties : {};
          var candidateId = normalizedCustomilyId(customilyPersonalizationIdFromProperties(candidateProperties));
          var value = candidateId ? 40 : 0;
          if (expectedPersonalizationId && candidateId === expectedPersonalizationId) value += 100;
          if (exactCustomilyPreviewUrlFromProperties(candidateProperties)) value += 20;
          if (snapshot.productHandle && cartItemHandle(candidate) === snapshot.productHandle) value += 10;
          return value;
        }
        return score(left) - score(right);
      }).pop();
      var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
      var exactPreviewUrl = exactCustomilyPreviewUrlFromProperties(properties);
      var personalizationId = customilyPersonalizationIdFromProperties(properties);
      if (!exactPreviewUrl && !personalizationId) return null;
      var archive = exactPreviewUrl ? uploadPreviewSnapshot(snapshot.id, exactPreviewUrl) : Promise.resolve(null);
      return archive.then(function (uploaded) {
        var published = publish('customization_completed', {
          trigger: clean(reason + '_cart_json', 64),
          snapshotAction: 'add_to_cart',
          customizationSnapshotId: snapshot.id,
          snapshotSequence: snapshot.sequence,
          previewObjectKey: uploaded && uploaded.objectKey ? uploaded.objectKey : undefined,
          previewContentType: uploaded && uploaded.contentType ? uploaded.contentType : undefined,
          previewUrl: exactPreviewUrl || undefined,
          personalizationId: personalizationId || undefined,
          lineItemProperties: properties,
          previewCaptureStatus: uploaded ? 'archived_r2' : exactPreviewUrl ? 'ready' : 'personalization_linked'
        }, true, snapshot.actionData || {});
        if (published) clearPendingCartSnapshot(snapshot.id);
        return published;
      });
    }).catch(function () {}).then(function () {
      state.pendingCartRecovery = false;
    });
  }

  function schedulePendingCartRecovery(reason) {
    [700, 1600, 3200, 6500].forEach(function (delay) {
      deferTracking('pending_cart_recovery_' + delay + 'ms', function () {
        recoverPendingCartPreview(reason + '_' + delay + 'ms');
      }, delay);
    });
  }

  function isCustomilyTarget(target) {
    return Boolean(target && target.closest && target.closest(rootSelector));
  }

  function isMaterialTarget(target) {
    return Boolean(target && target.matches && (
      target.matches('input[name="Material"], select[name="Material"], input[name="options[Material]"], select[name="options[Material]"]') ||
      /material/.test(normalizedName(target)) ||
      Boolean(target.closest && target.closest('[data-option-name*="material" i], .product-form__input--option-material'))
    ));
  }

  function isVariantTarget(target) {
    return Boolean(target && target.closest && target.closest(variantSelector));
  }

  function fieldFromClick(target) {
    if (!target || !target.closest) return null;
    var direct = target.closest('input, select, textarea');
    if (direct) return direct;
    var label = target.closest('label');
    if (label && label.control) return label.control;
    var option = target.closest('.customily-option, .customily-option-group, [class*="option"]');
    if (!option) return null;
    // Customily tile clicks often land on an image/span inside a group whose
    // first input is the default option. This handler runs after the click has
    // updated the UI, so prefer the currently selected/checked control rather
    // than the first control in DOM order.
    var controls = Array.prototype.slice.call(option.querySelectorAll('input, select, textarea'));
    return controls.find(isUsableField) || controls[0] || null;
  }

  function fieldLabel(target) {
    return normalizedName(target).replace(/^properties\[/, '').replace(/\]$/, '');
  }

  function previewObserverRoots() {
    var roots = Array.prototype.slice.call(document.querySelectorAll(rootSelector + ', ' + variantSelector));
    return roots.filter(function (root, index) {
      return roots.indexOf(root) === index && !roots.some(function (candidate, candidateIndex) {
        return candidateIndex !== index && candidate.contains(root);
      });
    });
  }

  function inspectPendingPreview() {
    if (!trackingAllowed() || !state.previewRequested) {
      stopPreviewObserver();
      return;
    }
    watchPreview();
    if (document.querySelector(previewSelector)) {
      return markPreviewCreated('preview_scoped_dom', state.previewCycle, false);
    }
  }

  function startPreviewObserver() {
    stopPreviewObserver();
    if (!trackingAllowed() || !state.previewRequested || !('MutationObserver' in window)) return;
    var roots = previewObserverRoots();
    if (!roots.length) {
      state.observerRootTimer = window.setTimeout(function () {
        if (trackingAllowed() && state.previewRequested) startPreviewObserver();
      }, 250);
      return;
    }
    state.previewObserver = new MutationObserver(function () {
      if (!trackingAllowed() || !state.previewRequested) {
        stopPreviewObserver();
        return;
      }
      window.clearTimeout(state.observerTimer);
      state.observerTimer = window.setTimeout(function () {
        runBudgeted('preview_mutation', inspectPendingPreview);
      }, OBSERVER_DEBOUNCE_MS);
    });
    roots.forEach(function (root) {
      state.previewObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'src', 'class']
      });
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!trackingAllowed() || !event.isTrusted) return;
    deferTracking('change', function () {
      if (!isCustomilyTarget(target) && !isVariantTarget(target) && !isMaterialTarget(target)) return;
      var changedMaterial = materialFromTarget(target);
      if (changedMaterial) state.lastMaterial = changedMaterial;
      rememberCustomerSelection(target, target);
      var label = fieldLabel(target);
      scheduleChanged(label || 'option_change');

      if (isMaterialTarget(target)) publish('material_selected');
      if (/breed/.test(label)) publish('breed_viewed');
      if (/engrav/.test(label) && target.checked) publish('engraving_added');
      if (target.type === 'file' && target.files && target.files.length > 0) {
        publish('pet_photo_submitted', { fileCount: clean(target.files.length, 4) });
      }
    });
  }, { capture: true, passive: true });

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!trackingAllowed() || !event.isTrusted) return;
    deferTracking('input', function () {
      if (!isCustomilyTarget(target)) return;
      rememberCustomerSelection(target, target);
      scheduleChanged(fieldLabel(target) || 'text_input');
    });
  }, { capture: true, passive: true });

  document.addEventListener('customily:material-changed', function () {
    if (!trackingAllowed()) return;
    deferTracking('material_changed', function () {
      if (Date.now() - state.lastTrustedInteractionAt >= 1500) return;
      var currentMaterial = materialFromDom();
      if (currentMaterial) state.lastMaterial = currentMaterial;
      fields().filter(isMaterialTarget).forEach(function (field) { rememberCustomerSelection(field, field); });
      scheduleChanged('material');
      publish('material_selected');
    });
  }, { passive: true });

  // Klaviyo dispatches this only after a form submission succeeds. Keep this
  // listener passive and defer all CRM work so the form UX and storefront are
  // never blocked. Do not identify from field input or an unsubmitted form.
  window.addEventListener('klaviyoForms', function (event) {
    var detail = event && event.detail;
    if (!trackingAllowed() || !detail || detail.type !== 'submit') return;
    deferTracking('klaviyo_form_submit', function () {
      var meta = detail.metaData && typeof detail.metaData === 'object' ? detail.metaData : {};
      var email = clean(meta.email || meta.$email || meta.Email || meta.email_address, 320).toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
      publish('customer_identified', {
        customerEmail: email,
        firstName: clean(meta.first_name || meta.firstName || meta.firstname || meta['First Name'], 120),
        identitySource: 'klaviyo_form_submit',
        klaviyoFormId: clean(detail.formId, 180),
        klaviyoCompanyId: clean(detail.companyId, 180)
      }, true);
    }, 0);
  }, { passive: true });

  // Begin only the in-memory 300px canvas conversion before Add to cart. This
  // is not a snapshot and sends no data. It gives the subsequent click enough
  // time to use the Customily canvas even when the cart UI changes quickly.
  document.addEventListener('pointerdown', function (event) {
    var origin = event.target;
    if (!trackingAllowed() || !event.isTrusted || !origin || !origin.closest) return;
    var target = origin.closest(atcSelector);
    if (!target) return;
    var text = clean(target.textContent, 160).toLowerCase();
    if (!/add to cart/i.test(text) && !target.closest('form[action*="/cart/add"]')) return;
    if (hasIncompleteRequiredCustomilyFields()) return;
    deferTracking('atc_preview_prewarm', prewarmAddToCartPreview, 0);
  }, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    var clickOrigin = event.target;
    if (!trackingAllowed() || !event.isTrusted || !clickOrigin || !clickOrigin.closest) return;
    var relevant = clickOrigin.closest(rootSelector + ', ' + variantSelector + ', ' + atcSelector + ', button, [role="button"], a');
    if (!relevant) return;
    deferTracking('click', function () {
      var clickedField = fieldFromClick(clickOrigin);
      if (isCustomilyTarget(clickOrigin) || isVariantTarget(clickOrigin) || isMaterialTarget(clickOrigin) || isMaterialTarget(clickedField)) {
        state.lastTrustedInteractionAt = Date.now();
        var clickedMaterial = materialFromTarget(clickOrigin) || materialFromTarget(clickedField);
        if (clickedMaterial) state.lastMaterial = clickedMaterial;
        ensureStarted('customily_click');
        deferTracking('option_click', function () {
          var selectedField = fieldFromClick(clickOrigin);
          if (!selectedField || !isUsableField(selectedField)) return;
          rememberCustomerSelection(selectedField, clickOrigin);
          scheduleChanged(fieldLabel(selectedField) || 'option_click');
        });
      }
      var target = clickOrigin.closest('button, [role="button"], a, ' + atcSelector);
      if (!target) return;
      var text = clean(target.textContent, 160).toLowerCase();

      if (/preview\s+(?:your\s+)?personalization/.test(text) && !/thumbnail/.test(target.className || '')) {
        var previewClickAt = Date.now();
        if (previewClickAt - state.lastPreviewClickAt < 1500) return;
        state.lastPreviewClickAt = previewClickAt;
        // Customily may show its own validation UI, but CRM must never create
        // evidence from an incomplete design. Do not prevent or delay the
        // click; simply leave no preview/value/snapshot trail in CRM.
        if (hasIncompleteRequiredCustomilyFields()) {
          document.documentElement.setAttribute('data-product-options-last-action', 'preview-blocked-required');
          state.previewRequested = false;
          stopPreviewObserver();
          return;
        }
        document.documentElement.setAttribute('data-product-options-last-action', 'preview-accepted');
        ensureStarted('preview_button');
        state.previewRequested = true;
        state.previewCycle += 1;
        var previewCycle = state.previewCycle;
        var previewSnapshotId = newSnapshotId('preview');
        state.previewSnapshots[previewCycle] = {
          id: previewSnapshotId,
          action: 'preview',
          sequence: state.snapshotSequence,
          actionData: personalizationData(),
          beforeUrl: previewUrlFromDom(),
          beforeFingerprint: previewFingerprint(previewImageSource())
        };
        state.previewSnapshots[previewCycle].selectionSignature = snapshotSelectionSignature(state.previewSnapshots[previewCycle].actionData);
        publish('preview_clicked', {
          snapshotAction: 'preview',
          customizationSnapshotId: previewSnapshotId,
          snapshotSequence: state.snapshotSequence,
          previewCaptureStatus: 'requested'
        }, true, state.previewSnapshots[previewCycle].actionData);
        scheduleExactCustomilyPreviewSync(state.previewSnapshots[previewCycle], 'preview_created');
        startPreviewObserver();
        publish('free_preview_requested');
        deferTracking('preview_retry_450ms', function () { return markPreviewCreated('preview_button_450ms', previewCycle, false); }, 450);
        deferTracking('preview_retry_1100ms', function () { return markPreviewCreated('preview_button_1100ms', previewCycle, false); }, 1100);
        deferTracking('preview_retry_2200ms', function () { return markPreviewCreated('preview_button_2200ms', previewCycle, false); }, 2200);
        deferTracking('preview_retry_3500ms', function () { return markPreviewCreated('preview_button_3500ms', previewCycle, false); }, 3500);
        deferTracking('preview_retry_6000ms', function () { return markPreviewCreated('preview_button_6000ms', previewCycle, false); }, 6000);
        deferTracking('preview_retry_10000ms', function () { return markPreviewCreated('preview_button_10000ms', previewCycle, false); }, 10000);
        deferTracking('preview_retry_16000ms', function () { return markPreviewCreated('preview_button_16000ms', previewCycle, false); }, 16000);
        deferTracking('preview_retry_final', function () { return markPreviewCreated('preview_button_final', previewCycle, true); }, 25000);
      }

      if (target.matches(atcSelector) && (/add to cart/i.test(text) || target.closest('form[action*="/cart/add"]'))) {
        // Same rule as Preview: no CRM customization snapshot until every
        // required Customily field is complete. Shopify/Customily retains full
        // control of validation and the actual add-to-cart behavior.
        if (hasIncompleteRequiredCustomilyFields()) {
          document.documentElement.setAttribute('data-product-options-last-action', 'add-to-cart-blocked-required');
          return;
        }
        document.documentElement.setAttribute('data-product-options-last-action', 'add-to-cart-accepted');
        publishCartSnapshot('add_to_cart');
      }
    });
  }, { capture: true, passive: true });

  var originalPreviewReady = window.__ssCustomilyPreviewReady;
  window.__ssCustomilyPreviewReady = function () {
    if (typeof originalPreviewReady === 'function') originalPreviewReady.apply(this, arguments);
    if (trackingAllowed() && state.previewRequested) {
      deferTracking('customily_ready', function () {
        // "Ready" can fire before the final gallery image/URL is drawable.
        // It is a retry signal, not permission to finalize capture_failed.
        return markPreviewCreated('customily_ready', state.previewCycle, false);
      });
    }
  };

  function watchPreview() {
    if (!trackingAllowed()) return;
    var preview = document.querySelector(previewSelector);
    if (!preview || preview.__soulyshineCrmObserved) return;
    preview.__soulyshineCrmObserved = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (!trackingAllowed()) return;
        deferTracking('preview_intersection', function () {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            state.previewVisible = true;
            if (state.previewCreatedCycle) publish('preview_viewed');
          });
        });
      }, { threshold: 0.35 }).observe(preview);
    }
  }

  function initialize() {
    if (state.initialized || !trackingAllowed()) return;
    state.initialized = true;
    var pageContext = {
      pageUrl: clean(window.location.origin + window.location.pathname, 2048),
      productHandle: productHandle() || undefined
    };
    if (analyticsProcessingAllowed()) {
      ensureBrowserIdentity();
      sendFirstPartyEvent('page_viewed', pageContext, 'shopify_pixel');
      if (pageContext.productHandle) sendFirstPartyEvent('product_viewed', pageContext, 'shopify_pixel');
      startSessionMeasurement();
    }
    schedulePendingCartRecovery('page_load');
    state.lastMaterial = materialFromDom();
    deferIdle('initialize_preview', watchPreview, 1500);
  }

  function enableTracking() {
    if (window.__soulyshineCrmDisabled === true) {
      disableTracking('local_kill_switch');
      return;
    }
    state.enabled = true;
    state.disabledReason = '';
    document.documentElement.setAttribute(
      'data-product-options-runtime-state',
      analyticsProcessingAllowed() ? 'enabled' : 'waiting_for_analytics_consent'
    );
    if (!analyticsProcessingAllowed()) return;
    if (state.initialized) {
      startSessionMeasurement();
      return;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true, passive: true });
    } else {
      initialize();
    }
  }

  function scheduleConfigRefresh() {
    window.clearTimeout(state.configTimer);
    state.configTimer = window.setTimeout(function () {
      if (document.visibilityState === 'hidden') {
        scheduleConfigRefresh();
        return;
      }
      refreshTrackingConfig();
    }, CONFIG_REFRESH_MS);
  }

  function refreshTrackingConfig() {
    fetch(trackingConfigEndpoint, {
      method: 'GET',
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('tracking_config_unavailable');
      return response.json();
    }).then(function (config) {
      if (config && config.trackingEnabled === true) enableTracking();
      else disableTracking('remote_kill_switch');
    }).catch(function () {
      // The remote switch is advisory. A proxy outage must never interrupt the
      // local best-effort fallback or any storefront interaction.
      enableTracking();
    }).then(scheduleConfigRefresh);
  }

  window.__soulyshineCrmKillSwitch = function (disabled) {
    window.__soulyshineCrmDisabled = disabled !== false;
    if (window.__soulyshineCrmDisabled) disableTracking('local_kill_switch');
    else refreshTrackingConfig();
  };

  function handleAnalyticsConsentChange() {
    if (!state.enabled || window.__soulyshineCrmDisabled === true) return;
    if (!analyticsProcessingAllowed()) {
      document.documentElement.setAttribute('data-product-options-runtime-state', 'waiting_for_analytics_consent');
      state.previewRequested = false;
      stopPreviewObserver();
      window.clearTimeout(state.changeTimer);
      state.changeTimer = 0;
      return;
    }
    document.documentElement.setAttribute('data-product-options-runtime-state', 'enabled');
    initialize();
  }

  function loadCustomerPrivacyApi() {
    document.documentElement.setAttribute('data-product-options-runtime-state', 'loading_consent_api');
    if (
      window.Shopify &&
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
    ) {
      refreshTrackingConfig();
      return;
    }
    if (!window.Shopify || typeof Shopify.loadFeatures !== 'function') {
      refreshTrackingConfig();
      return;
    }
    Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function () {
      // Fail closed when Shopify cannot expose the privacy API. The regular
      // config refresh retries safely without touching Customily or commerce.
      refreshTrackingConfig();
    });
  }

  document.addEventListener('visitorConsentCollected', handleAnalyticsConsentChange, { passive: true });
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', handleAnalyticsConsentChange, { passive: true });

  window.setTimeout(loadCustomerPrivacyApi, 0);
})();
